// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a50f6d3c","900":"82b48604"}[chunkId] + ".chunk.js";
};